import { getAPICall, postAPICall } from './BaseAPI';

export const createReconciliation = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('reconciliation/create', payload, cb);
};

export const getReconciliationsList = (cb=(jR, s, e)=>{}) => {
  getAPICall('reconciliation/list', cb);
};

export const getReconciliationDetail = (id, cb=(jR, s, e)=>{}) => {
  getAPICall(`reconciliation/${id}`, cb);
};

export const scanReconciliationItem = (id, payload, cb=(jR, s, e)=>{}) => {
  postAPICall(`reconciliation/${id}/scan`, payload, cb);
};

export const setReconciliationItemAction = (id, payload, cb=(jR, s, e)=>{}) => {
  postAPICall(`reconciliation/${id}/action`, payload, cb);
};

export const processReconciliation = (id, cb=(jR, s, e)=>{}) => {
  postAPICall(`reconciliation/${id}/process`, {}, cb);
};
